<template>
    <rkm-layout-body title="Lista de logradouro">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-logradouro-create' })"
                color="primary"
                authorize="store-cadastro-logradouro"
            >
                Cadastrar logradouro
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/logradouro/List'

export default {
    components: { List },
}
</script>